import { BaseUserDto, NisyClient, NisyEvents, NisyTrackOptions } from '@repo/utils';
import { useCallback, useMemo } from 'react';

export const useNisy = () => {
  const onTrack = useCallback(async (event: NisyEvents, data: Record<string, any>, options?: NisyTrackOptions) => {
    await NisyClient.track(event, data, options);
  }, []);

  const onIdentify = useCallback(async (user: BaseUserDto, options?: NisyTrackOptions) => {
    await NisyClient.identify(user, options);
  }, []);

  return useMemo(
    () => ({
      onTrack,
      onIdentify,
    }),
    [onTrack, onIdentify],
  );
};
